module.exports = __webpack_public_path__ + "img/Rookie-5.75127526.gif";